import { Resource } from './resource.interface';

export const productResources: Resource[] = [
  {
    thumbnail: require('../assets/images/thumbnails/HCP-PREVAIL-I-&-II-Reprint.png'),
    title: 'HCP PREVAIL I & II Reprint',
    url: './pdfs/HCP-PREVAIL-I-&-II-Reprint.pdf',
    type: 'pdf'
  },
  {
    thumbnail: require('../assets/images/thumbnails/lisa-1.png'),
    title: 'LATUDA Efficacy Brochure',
    url: './pdfs/LATUDA-Efficacy-Brochure.pdf',
    type: 'pdf'
  },
  {
    thumbnail: require('../assets/images/thumbnails/lottie-01.png'),
    title: 'Patient Profile - <em>Lottie</em>',
    url: './pdfs/Patient-Profile---Lottie.pdf',
    type: 'pdf'
  }
];

export const videoLibrary: Resource[] = [
  {
    thumbnail: require('../assets/images/thumbnails/impactofbipolardepression.png'),
    title: 'Product Theater Enduring Video - Questions to Consider',
    url: './videos/impactofbipolardepression.mp4',
    type: 'video'
  },
  {
    thumbnail: require('../assets/images/thumbnails/nei_product_theatre.png'),
    title: 'Product Theater Enduring Video - Engage in a Case',
    url: './videos/nei_product_theatre.mp4',
    type: 'video'
  },
  {
    thumbnail: require('../assets/images/thumbnails/led-wall-animation.png'),
    title: 'LATUDA Campaign Animation',
    url: './videos/led-wall-animation.mp4',
    type: 'video'
  },
  {
    thumbnail: require('../assets/images/thumbnails/bpdmoa.png'),
    title: 'LATUDA BPD MOA Video',
    url: './videos/bpdmoa.mp4',
    type: 'video'
  }
];
